import { useQuery } from '@tanstack/react-query';
import { blogService } from '../services/blog/blog-service';
import type { BlogFilter, BlogPagination } from '../types/blog';

export function useBlogPosts(
  filter?: BlogFilter,
  pagination?: BlogPagination
) {
  return useQuery({
    queryKey: ['blogPosts', filter, pagination],
    queryFn: () => blogService.getAllPosts(filter, pagination),
    staleTime: 300000, // 5 minutes
    cacheTime: 600000, // 10 minutes
    keepPreviousData: true,
  });
}

export function useBlogPost(slug: string) {
  return useQuery({
    queryKey: ['blogPost', slug],
    queryFn: () => blogService.getPostBySlug(slug),
    staleTime: 600000, // 10 minutes
    enabled: !!slug,
  });
}

export function useFeaturedPosts(limit: number = 3) {
  return useQuery({
    queryKey: ['featuredPosts', limit],
    queryFn: () => blogService.getFeaturedPosts(limit),
    staleTime: 300000, // 5 minutes
  });
}

export function useRelatedPosts(post: any, limit: number = 3) {
  return useQuery({
    queryKey: ['relatedPosts', post?.id, limit],
    queryFn: () => blogService.getRelatedPosts(post, limit),
    enabled: !!post,
    staleTime: 600000, // 10 minutes
  });
}